module.exports = __webpack_public_path__ + "media/svg-new/support-pink-astronauta-c1d2983d.svg";